import AppConfig from "config";
import axios from "axios";
const jwtToken = localStorage.getItem('access_token');

const TranscriptsController = {

async listTranscriptsSearch(filter) {
    try {
      const response = await axios.post(AppConfig.BACKEND_URL_REFATORADO + `transcripts_page/search_by_id_or_audit`, {
        filter: filter,
      }, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });
      return response.data.result;
    } catch (error) {
      console.error("Error creating user:", error);
      throw error;
    }
  }

}

export default TranscriptsController;